import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation, Link  } from 'react-router-dom';
import { useBookpalNavigate } from 'component/common/custom/BookpalLink';
import { ApiAuthInfo } from 'api/Auth';
import BookpalLink from 'component/common/custom/BookpalLink';
import useSelectModal from 'component/common/modal/useSelectModal';
import useCouponInfoModal from 'component/common/modal/useCouponInfoModal';


import style from './Refund.module.scss';


import useConfirmCustomRefundModal from 'component/common/modal/useConfirmCustomRefundModal';
import { appSetClose, isApp } from 'utils/AppUtil';
import { ApiRefundInfo, ApiRefundApply } from 'api/Refund';
import useAlertModal from 'component/common/modal/useAlertModal';

import RefundResult from './RefundResult';
import RefundResultSuccess from './RefundResultSuccess';
import RefundResultFail from './RefundResultFail';
// import OrderResult from './OrderResult';


function useQuery() {
    return new URLSearchParams(useLocation().search);
  }


function Refund(){

    const navigate = useBookpalNavigate();
    const location = useLocation();

    const [info, setInfo] = useState(null);
    const [isSubmit, setIsSubmit] = useState(false);

    const [acctNo, setAcctNo] = useState(null);
    const [acctHolder, setAcctHolder] = useState("");

    const [CouponModal, couponShow] = useCouponInfoModal();
    const [AlertModal, alert] = useAlertModal();
    const [ConfirmSubmitModal, confirmSubmitShow] = useConfirmCustomRefundModal();

    

    const bankCategoryData = {
        "0":"은행을 선택해주세요.",
        "003":"기업은행",
        "004":"국민은행",
        "011":"농협은행",
        "020":"우리은행",
        "023":"SC은행",
        "027":"한국씨티은행",
        "031":"대구은행",
        "032":"부산은행",
        "034":"광주은행",
        "035":"제주은행",
        "037":"전북은행",
        "039":"경남은행",
        "045":"새마을금고중앙회",
        "048":"신협중앙회",
        "071":"우체국",
        "081":"하나은행 (구 외환포함)",
        "088":"신한은행",
        "089":"K뱅크" ,
        "090":"카카오뱅크",
        "092":"토스뱅크",
    };

    const [BankCategoryModal, bankCategoryModalShow, bankCategorySelectKey, initBankCategory] = useSelectModal(bankCategoryData, "0");

    const handlerMemberInfoSubmit = ApiRefundInfo({
        onSuccess:(data)=>{
            if(data?.status === true){
                if(data?.result?.is_login === false){
                    alert('로그인 해주세요.');
                    window.close();
                    
                    return;
                }

                setInfo(data?.result);
                return;
            }

            console.log(data);
            alert('시스템 오류입니다. 다시 시도해주세요.');
            //window.close();
            return;
        },
        onError:(e)=>{
            alert("통신이 실패하였습니다. 다시 시도해주세요.");
            //window.close();
        }
    });
    const handlerRefundApplySubmit = ApiRefundApply({
        onSuccess:(data)=>{
            console.log(data);

            if(data?.status === true){
                let result = data?.result;

                if(result?.is_success == true){
                    alert("환불이 정상적으로 접수되었습니다.",null, ()=>{
                        window.location.reload(true);
                    },true);
                }
                return;
            }


            if(data?.status === false && data?.message == "already_apply_data"){
                alert("이미 환불을 신청하셨습니다",null, ()=>{
                    window.location.reload(true);
                },true);
                return;
            }

            return;
        },
        
        onError:(e)=>{
            alert("통신이 실패하였습니다. 다시 시도해주세요.");
            //window.close();
        }
    });

    const handlerSubmit = ()=>{
        confirmSubmitShow({
            title:"환불 신청을 진행하시겠습니까?",
            successBtnTitle:"신청하기",
            cancleBtnTitle:"취소",
            successAction:()=>{
                handlerRefundApplySubmit({
                    acct_no:acctNo,
                    acct_holder:acctHolder,
                    acct_bank_code:bankCategorySelectKey,
                });
            },
        });
    }

    const handlerBack = () => {
        navigate(-1);
    }

    // console.log(location);

    useEffect(()=>{
        handlerMemberInfoSubmit();
    },[]);

    useEffect(()=>{
        let checkSubmit = 0;
        if(bankCategorySelectKey != 0 && bankCategorySelectKey > 0){
            checkSubmit++;
        }

        if(acctNo != null && acctNo > 0){
            checkSubmit++;
        }

        if(acctHolder != ""){
            checkSubmit++;
        }

        if(checkSubmit >= 3){
            setIsSubmit(true);
        } else {
            setIsSubmit(false);
        }
    },[bankCategorySelectKey, acctNo, acctHolder]);

    

    if(info === null){
        return (
            <>
                Loading...
                <AlertModal />
            </>
        );
    }

    if(info?.is_refund_apply == true){
        if(info?.status == "D"){
            return (
                // <></>
                <RefundResult 
                    refundCouponCnt={info?.refund_coupon_cnt}
                    acctBankCode={info?.acct_bank_code}
                    acctBankNm={bankCategoryData[info?.acct_bank_code] ?? ""}
                    acctHolder={info?.acct_holder}
                    acctNo={info?.acct_no}
                    regDate={info?.reg_date}
                />
            );
        }
        if(info?.status == "S"){
            return (
                // <></>
                <RefundResultSuccess 
                    refundCouponCnt={info?.refund_coupon_cnt}
                    refundCouponPrice={info?.refund_coupon_price}
                    acctBankCode={info?.acct_bank_code}
                    acctBankNm={bankCategoryData[info?.acct_bank_code] ?? ""}
                    acctHolder={info?.acct_holder}
                    acctNo={info?.acct_no}
                    regDate={info?.reg_date}
                />
            );
        }
        if(info?.status == "F"){
            return (
                // <></>
                <RefundResultFail
                    refundCouponCnt={info?.refund_coupon_cnt}
                    refundCouponPrice={info?.refund_coupon_price}
                    acctBankCode={info?.acct_bank_code}
                    acctBankNm={bankCategoryData[info?.acct_bank_code] ?? ""}
                    acctHolder={info?.acct_holder}
                    acctNo={info?.acct_no}
                    regDate={info?.reg_date}
                />
            );
        }
    }

    return (
        <>
            {/* <!-- 충전 헤더 --> */}
            <div id="TopHeader" className={"color-bg-01 title_header " + style['TopHeader'] + " " + style['title_header']}>
                <div className={"title_menu wrapper " + style['title_menu']}>
                    <div className={"btns left_btns " + style['btns'] + " " + style['left_btns']}></div>
                    <div className={"title-04 color-txt-normal text_overflow " + style['text_overflow'] + " " + style['title-04']}>잔여 쿠폰 환불 신청</div>
                    <div className={"btns right_btns " + style['btns'] + " " + style['right_btns']}>
                        <button 
                            type="button" 
                            className={"close_btn " + style['close_btn']} 
                            onClick={()=>{
                                window.close();
                                appSetClose();
                            }}
                            ></button>
                    </div>
                </div>
            </div>

            {/* <!-- container --> */}
            <div id="container" className={"s_wrap wrapper " + style['container'] + " " + style['s_wrap'] + " " + style['wrapper']} style={{marginTop:"0", marginBottom:"0px"}}>
                <section className={"charge_box " + style['charge_box']}>
                    <div className={"area_box " + style['area_box']}>
                        <div className={"my_box section " + style['my_box'] + " " + style['section']} style={{padding:"0"}}>
                            
                            <div className={"my_coupon radius-sm gold_opacity-10 bg clearfix " + style['my_coupon']}>
                                <div className={"left " + style['left']}>
                                    <p className="title-01-b color-txt-normal">환불 가능 쿠폰</p>
                                </div>
                                <div className={"right " + style['right']}>
                                    <p className="number title-03-m color-txt-normal"><span className="title-03">{info?.coupon_cnt_txt ?? 0}</span>개</p>
                                </div>
                            </div>
                        </div>
                        <div className={"temp_list_type section " + style['temp_list_type'] + " " + style['section']} style={{padding:"0"}}>
                            <div className={"list " + style['list']} > 
                                <div className="list_1" style={{display:""}}>
                                    <div className={"input_box article " + style['article']}>
                                        <p className={"input_txt body-01 color-txt-01 " + style['input_txt']}>은행</p>
                                        {/* <!-- 선택전 --> */}
                                        <div className={"select_box text_input border-line border-soild radius-sm color-bg-01 color-border-02 " + style['select_box'] + " " + style['text_input']}>
                                            <button type="button" onClick={bankCategoryModalShow}>
                                                <span className={"body-03 " + (bankCategorySelectKey != 0 ? "color-txt-normal" : "color-txt-muted")}>{bankCategoryData[bankCategorySelectKey]}</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className={"input_box article " + style['article']}>
                                        <p className="input_txt body-01 color-txt-01">계좌번호</p>
                                        <div className="text_input border-line border-soild radius-sm color-bg-01 color-border-02">
                                            <input 
                                                type="number" 
                                                placeholder="'-' 제외 입력" 
                                                className={"color-txt-normal body-03 " + style['no_spinner']}
                                                value={acctNo}
                                                onChange={(e)=>{setAcctNo(e.target.value)}}
                                                />
                                            <p className="right_btns">
                                                <span 
                                                    className="btnClear" 
                                                    style={{display:(acctNo != "" && acctNo != null && acctNo > 0?"block":"none")}}
                                                    onClick={()=>{setAcctNo("")}}
                                                    />
                                            </p>
                                        </div>
                                    </div>
                                    <div className={"input_box article " + style['article']}>
                                        <p className="input_txt body-01 color-txt-01">예금주명</p>
                                        <div className="text_input border-line border-soild radius-sm color-bg-01 color-border-02">
                                            <input 
                                                type="text" 
                                                placeholder="실명입력" 
                                                className={"color-txt-normal body-03 " + style['no_spinner']}
                                                value={acctHolder}
                                                onChange={(e)=>{setAcctHolder(e.target.value)}}
                                                />
                                            <p className="right_btns">
                                                <span 
                                                    className="btnClear" 
                                                    style={{display:(acctHolder != ""?"block":"none")}}
                                                    onClick={()=>{setAcctHolder("")}}
                                                    />
                                            </p>
                                        </div>
                                    </div>

                                    <div className={"tit_con section clearfix " + style['tit_con'] } style={{height:"auto",letterSpacing:"0.5px", lineHeight:"1.3"}}>
                                        <div className={"grade_up top_con radius-sm red_opacity-05 bg " + style['grade_up'] + " " + style['top_con'] + " " + style['bg']} style={{padding:"10px",backgroundColor:"#eee"}}>
                                            <p className={"title body-01 color-txt-muted " + style['title']}><span className="color-txt-normal" style={{fontSize:"0.85rem", lineHeight:"1.0",width:"100%"}}>
                                                
                                                <b className='title-01-b ' style={{fontSize:"0.85rem"}}>* 유의사항 안내</b><br />
                                                <br />
                                                <p className={style['dot-item']}>유효한 유료 쿠폰만 환불 가능하며, 선물이용권, 선물소장권은 환불대상이 아닙니다.</p>
                                                <p className={style['dot-item']}>유료 쿠폰은 최소 1개 이상부터 환불 신청이 가능합니다.</p>
                                                <p className={style['dot-item']}>국내 계좌만 신청 가능하며 그 외 다른 계좌(증권계좌, 해외계좌 등)는 신청이 불가합니다.</p>
                                                <p className={style['dot-item']}>원활한 환불 처리를 위해 계좌번호와 예금주명을 정확히 입력해 주시기 바랍니다. 정보 오기재로 인한 입금 불가에 대하여서는 책임지지 않습니다.</p>
                                                <p className={style['dot-item']}>환불 신청과 동시에 모든 쿠폰은 전량 차감되며, 수량이 0으로 변경됩니다.</p>
                                                <p className={style['dot-item']}>환불 신청 이후 추가 충전 및 환불 신청 취소가 불가하므로 신중하게 신청하여 주시기 바랍니다.</p>

                                            </span>
                                            {/* 매월 1일, 최근 3개월 결제금액에 따라 결정됩니다. */}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="fixed_button">
                                    <button 
                                        type="button" 
                                        className="button btn_01 filled btn-05 white-always txt" 
                                        disabled={!isSubmit}
                                        onClick={handlerSubmit}
                                        >신청하기</button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </section>
            </div>
            <AlertModal />
            <BankCategoryModal />
            <ConfirmSubmitModal />
            {/* <!-- container --> */}

            {/* <Footer /> */}
        </>
    );
}


export default Refund;